import { h, Fragment, Component } from 'preact'
import MarkerPopup from './MarkerPopup'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

class Marker extends Component {
  constructor(props) {
    super(props)

    this.state = {
      active: false
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.activeHover !== this.props.activeHover) {
      if (this.props.post.activeHover) {
        // Disable this function untill further notice
        // this.props.handleClick(this.props.lat, this.props.lng)
      }
    }
  }

  handleClick() {
    this.setState({
      active: true
    })

    this.props.handleClick(this.props.lat, this.props.lng)
  }

  handleClose() {
    this.setState({
      active: false
    })
  }

  render() {
    const house_color = this.props.post.house_status[0]
    ? this.props.post.house_status[0] === 'Te huur'
      ? 'free'
      : this.props.post.house_status[0] === 'Binnen 3 maanden vrij'
      ? 'soon'
      : this.props.post.house_status[0] === 'Binnenkort beschikbaar'
      ? 'soon'
      : this.props.post.house_status[0] === 'Verhuurd'
      ? 'occupied'
      : ''
    : ''
    let size =
      this.props.zoom <= 10
        ? 20 / (11 - this.props.zoom)
        : 20 * (this.props.zoom - 9)

    return (
      <Fragment>
        <div
          className={`c-housing-marker ${this.props.zoom < 8 ? 'c-housing-marker--no-background' : ''} 
          ${this.props.zoom > 14 ? 'c-housing-marker--large' : ''} 
          ${this.props.activeHover ? 'active' : ''}`}
          // style={{ width: `${size}rem`, height: `${size}rem` }}
        />

        <svg
          className={`c-icon c-housing-marker__icon ${
            this.props.activeHover ? 'active' : ''
          } ${this.props.zoom > 14 ? 'c-housing-marker__icon--large' : ''} ${
            this.state.active ? 'inactive' : ''
          }
          c-housing-marker__icon--${house_color ? house_color : 'no-status'}`}
          onClick={this.handleClick.bind(this)}
        >
          <use href="#house-marker-app" xlinkHref="#house-marker-app" />
        </svg>

        {this.state.active ? (
          <MarkerPopup
            post={this.props.post}
            handleClose={this.handleClose.bind(this)}
          />
        ) : null}
      </Fragment>
    )
  }
}

export default Marker



// WEBPACK FOOTER //
// ./src/js/housing/components/Marker.js